import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

export const fetchPrintSettings = createAsyncThunk('settings/fetchPrint', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('Settings/print');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

export const savePrintSettings = createAsyncThunk('settings/savePrint', async (dto, { rejectWithValue }) => {
  try {
    await api.post('Settings/print', dto);
    toast.success('Print settings saved');
    return dto;
  } catch (err) {
    toast.error(err.response?.data?.message || err.message);
    return rejectWithValue(err.message);
  }
});

export const fetchCompanySettings = createAsyncThunk('settings/fetchCompany', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('Settings/company');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

export const saveCompanySettings = createAsyncThunk('settings/saveCompany', async (dto, { rejectWithValue }) => {
  try {
    await api.post('Settings/company', dto);
    toast.success('Company settings saved');
    return dto;
  } catch (err) {
    toast.error(err.response?.data?.message || err.message);
    return rejectWithValue(err.message);
  }
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    print: {
      labelWidthMm: 17,
      labelHeightMm: 30,
      qrSizeMm: 17,
      columnsPerRow: 1,
      showProductName: true,
      showSerialNo: true,
      showBatchNo: true,
      showColorName: false,
      showModelNo: false,
      showCompanyName: false,
      warrantyDelayDays: 60
    },
    company: {
      colorMode: 'Multi', // 'Multi' | 'Single'
      warrantyStartMode: 'AfterDispatch', // 'AfterDispatch' | 'AfterQRGenerate'
      warrantyDelayDays: 60,
      allowedProductTypes: 'WarrantyOnly',
    },
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrintSettings.fulfilled, (s, a) => {
        s.print = a.payload;
      })
      .addCase(savePrintSettings.fulfilled, (s, a) => {
        s.print = a.payload;
      })
      .addCase(fetchCompanySettings.fulfilled, (s, a) => {
        s.company = a.payload;
      })
      .addCase(saveCompanySettings.fulfilled, (s, a) => {
        s.company = { ...(s.company || {}), ...a.payload };
      });
  }
});

export default settingsSlice.reducer;
